export const dtoIsYes = (e: "yes" | "no" | "") => e === "yes";
